<template>
  <modal
    v-slot="{ data }"
    name="scanToPayReceiptModal"
    modal-style="compact"
    :display-header-title="false"
  >
    <scan-to-pay-receipt
      :receipt-token="data.receiptToken"
      @confirm-handler="data.confirmHandler"
    />
  </modal>
</template>


<script>
  import ScanToPayReceipt from './scan-to-pay-receipt/index.vue';


  export default {
    name: 'ScanToEarnReceiptModal',

    components: {
      ScanToPayReceipt
    }
  };
</script>
